import FormErrorMessage from '@/app/common/components/FormErrorMessage'
import { Input } from '@/app/common/components/input/Input'
import Label from '@/app/common/components/Label'
import { Control, Controller, FieldErrors, UseFormWatch } from 'react-hook-form'
import { YesOrNoOptions } from '../../constants/constants'
import FormSection from '@/common/components/FormSection.tsx'
import RadioButtonQuestion from '../form_elements/RadioButtonQuestion'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shad/ui/select.tsx'
import { StateList } from '@/queries/common/requests.ts'
import { SchoolFormValues } from '@/pages/providers/components/SchoolForm/schoolForm.schema.ts'

type Props = {
  control: Control<SchoolFormValues>
  watch: UseFormWatch<SchoolFormValues>
  states: StateList
  errors: FieldErrors<SchoolFormValues>
}

export default function DifferentMailingAddressSection(props: Props) {
  const { control, errors, states, watch } = props

  return (
    <div>
      <FormSection>
        {/* Is your mailing address the same as your physical address? */}
        <Controller
          name="MailingAddressSchema.isMailingAddressSame"
          control={control}
          render={({ field }) => (
            <RadioButtonQuestion
              question="Is your mailing address the same as your physical address?"
              options={YesOrNoOptions}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
        <FormErrorMessage
          message={errors.MailingAddressSchema?.isMailingAddressSame?.message}
        />

        {/* Conditionally render mailing address fields if not the same */}
        {watch('MailingAddressSchema.isMailingAddressSame') === 'No' && (
          <div className="mt-6">
            {/* Mailing Street Address */}
            <FormSection>
              <Label htmlFor="mailingStreetAddress">
                Mailing Street Address
                <span className="text-red-500">*</span>
              </Label>
              <Controller
                name="MailingAddressSchema.mailingStreetAddress"
                control={control}
                render={({ field }) => (
                  <Input
                    id="mailingStreetAddress"
                    {...field}
                    placeholder="Enter mailing street address"
                  />
                )}
              />
              <FormErrorMessage
                message={
                  errors.MailingAddressSchema?.mailingStreetAddress?.message
                }
              />
            </FormSection>

            <FormSection>
              {/* Mailing Street Address Line 2 */}
              <Label htmlFor="mailingStreetAddress2">
                Mailing Street Address Line 2 (Optional)
              </Label>
              <Controller
                name="MailingAddressSchema.mailingStreetAddress2"
                control={control}
                render={({ field }) => (
                  <Input
                    id="mailingStreetAddress2"
                    {...field}
                    placeholder="Enter mailing street address line 2 (optional)"
                  />
                )}
              />
              <FormErrorMessage
                message={
                  errors?.MailingAddressSchema?.mailingStreetAddress2?.message
                }
              />
            </FormSection>

            <FormSection>
              {/* Mailing City */}
              <Label htmlFor="mailingCity">
                Mailing City<span className="text-red-500">*</span>
              </Label>
              <Controller
                name="MailingAddressSchema.mailingCity"
                control={control}
                render={({ field }) => (
                  <Input
                    id="mailingCity"
                    {...field}
                    placeholder="Enter mailing city"
                  />
                )}
              />
              <FormErrorMessage
                message={errors?.MailingAddressSchema?.mailingCity?.message}
              />
            </FormSection>

            {/* Mailing State */}
            <FormSection>
              <Label htmlFor="mailingState">
                Mailing State<span className="text-red-500">*</span>
              </Label>
              <Controller
                name="MailingAddressSchema.mailingState"
                control={control}
                render={({ field }) => (
                  console.log(field.value, 'heres the state'),
                  (
                    <Select
                      value={field.value}
                      onValueChange={field.onChange}
                      name="mailingState"
                    >
                      <SelectTrigger id="mailingState" className="w-full">
                        <SelectValue placeholder="Select state" />
                      </SelectTrigger>
                      <SelectContent>
                        {states.data.map((state) => (
                          <SelectItem
                            key={state.code}
                            value={state.id.toString()}
                          >
                            {state.name}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  )
                )}
              />
              <FormErrorMessage
                message={errors.MailingAddressSchema?.mailingState?.message}
              />
            </FormSection>

            <FormSection>
              {/* Mailing Zip Code */}
              <Label htmlFor="mailingZipCode">
                Mailing Zip Code<span className="text-red-500">*</span>
              </Label>
              <Controller
                name="MailingAddressSchema.mailingZipCode"
                control={control}
                render={({ field }) => (
                  <Input
                    id="mailingZipCode"
                    {...field}
                    placeholder="Enter mailing zip code"
                  />
                )}
              />
              <FormErrorMessage
                message={errors.MailingAddressSchema?.mailingZipCode?.message}
              />
            </FormSection>
          </div>
        )}
      </FormSection>
    </div>
  )
}
